
var Model = require("../types/Model.js");

/**
 * This Model is used to determine when to display the logout confirmation modal.
 *  * @type {Model}
 */

module.exports = Model({
	name: "newreading",
	init: init,
	triggers: triggers,

	_section: null,
});

const SECTION_TO_NAME = {
	"activity": "activity",
	"bloodsugar": "blood sugar",
	"weight": "weight",
	"bloodpressure": "blood pressure",
	"bloodoxygen": "blood oxygen",
	"bodytemperature": "body temperature",
};

function triggers() {
	return {
		"show": show_edit_modal,
		"hide": hide_edit_modal,
		"confirm": show_confirm,
		"deny": hide_confirm,
	};
}
function init() {
	this.push({
		open: false,
		confirm: false,
		section: null,
	});
}


function show_edit_modal(section) {
	this.emit("keyboard:trigger:close");
	this.extend({
		open: true,
		confirm: false,
	});
	this._section = section;
	this.emit("usermetrics:trigger:track", `begin entering new ${SECTION_TO_NAME[section] || section} reading via manual entry`);
}

function hide_edit_modal(cancelled) {
	cancelled && this.emit("usermetrics:trigger:track", `cancel new ${SECTION_TO_NAME[this._section] || this._section} reading via manual entry`);
	this.extend({
		open: false,
		confirm: false,
	});
	this._section = null;
}

function show_confirm() {
	this.extend({
		confirm: true,
		open: true
	});
}

function hide_confirm() {
	this.extend({
		confirm: false,
		open: true
	});
	this.emit("usermetrics:trigger:track", `close confirm submit ${SECTION_TO_NAME[this._section] || this._section} confirmation popup`);
}
